<div class="modal-header">
    <h4 class="modal-title">Resumen de Actividad</h4>
    <button type="button" class="close" aria-label="Close" (click)="closeModal()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    <p>Modal Resumen Activity Works!</p>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="closeModal()">Cerrar</button>
</div>